import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Divider from "material-ui/Divider";
import {
  IconButton,
  StyledButton,
  TextField,
  Loadable,
  DataTable
} from "components/support";

class InvoiceInfoView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { invoice, isCreated, loading, inactiveSeries } = viewModel;
    const { serie_number, last_nfce_number } = invoice;

    const configDataTable = {
      identifier: "_id",
      columns: [
        {
          accessor: "serie_number",
          Header: "Número de Série",
          align: "center"
        },
        {
          accessor: "last_nfce_number",
          Header: "Sequencial da Nota Fiscal",
          align: "center"
        },
        {
          Header: "Ativar Série",
          align: "center",
          Cell: props => (
            <IconButton
              mini
              icon="check_circle"
              onClick={() => {
                presenter.onActivateSerie(props.row._original);
              }}
            />
          )
        }
      ]
    };

    return (
      <Loadable loading={loading}>
        <div className="grid-container">
          <Row>
            <Col xs={12} md={5}>
              <TextField
                fullWidth
                underlineShow={false}
                value={serie_number}
                onChange={(_, value) =>
                  presenter.onChange("serie_number", value)
                }
                floatingLabelFixed
                floatingLabelText="Número de Série da Nota Fiscal"
                disabled={isCreated}
              />
            </Col>
            <Col xs={12} md={5}>
              <TextField
                fullWidth
                underlineShow={false}
                value={last_nfce_number}
                onChange={(_, value) =>
                  presenter.onChange("last_nfce_number", value)
                }
                floatingLabelFixed
                floatingLabelText="Sequencial da Nota Fiscal"
                disabled={isCreated}
              />
            </Col>
            <Col xs={12} md={2}>
              <StyledButton
                label={
                  isCreated ? "Desativar Série" : "Criar Série e Sequencial"
                }
                onTouchTap={() => presenter.handleClick()}
                accent
                style={{ marginTop: 38 }}
              />
            </Col>
          </Row>
        </div>
        <Divider className="mt-sm" />

        <div className="grid-container">
          <Row>
            <Col xs={12}>
              <h3>Séries inativas</h3>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <DataTable
                resultSet={inactiveSeries}
                config={configDataTable}
                showPagination={false}
              />
            </Col>
          </Row>
        </div>
      </Loadable>
    );
  }
}

export default InvoiceInfoView;



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/invoice-info/view.jsx